import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../../hook-utils';
import { TaskItemAction } from '../../model';
import { actions } from '../../store';
import { getInstantMessageById } from '../../store/reducers/instantmessager';
import Modal from '../Modal';
import { CallViewByItemDetails } from './CallDetailsPanel';
import './ChatViewPanel.scss';
import { InstantMessagerView } from '../IM/InstantMessagerView';

export interface ShowChatState {
  id: string
}

export default function ChatViewPanelByChatId({ id, onClose }: { id: string, onClose(): void }) {
  const conversation = useSelector(s => getInstantMessageById(s, id))
  const dispatch = useDispatch()

  useEffect(() => {
    if (conversation) return
    dispatch(actions.fetchInstantMessageReadRequest(id))
  }, [dispatch, id, conversation])

  function handleClose() {
    //should do this but need to check if it's active in agent view before doing it
    //dispatch(actions.removeMediaItem(chatId))
    onClose()
  }

  if (!conversation) { return null }

  const customStyles = {
    content: {
      width: '50%',
      height: '70%',
    },
  };

  return <Modal style={customStyles} isOpen={true} className='ChatViewPanelByChatId'>
    <CallViewByItemDetails itemId={id} itemType='TC' itemAction={TaskItemAction.none} onClose={handleClose} />
    <div className='title'>
      <h2>Chat</h2>
    </div>
    <ChatViewPanel id={id} />
  </Modal>
}

export function ChatViewPanel({ id, onClose }: { id: string, onClose?(): void }) {
  const conversation = useSelector(s => getInstantMessageById(s, id))
  const dispatch = useDispatch()

  useEffect(() => {
    if (conversation) return
    dispatch(actions.fetchInstantMessageReadRequest(id))
  }, [dispatch, id, conversation])

  if (!conversation) { return null }


  return <div className='ChatViewPanel'>
    <InstantMessagerView id={id} />
  </div>
}
